import React from 'react';
import { Trophy, Medal } from 'lucide-react';

const STYLES = {
  'Winner': { cls: 'bg-amber-100 text-amber-800 border-amber-300', Icon: Trophy },
  'Runner-up': { cls: 'bg-slate-100 text-slate-700 border-slate-300', Icon: Medal },
};

export const AwardBadge = ({ award, testId }) => {
  const { cls, Icon } = STYLES[award] || { cls: 'bg-brand-accent/15 text-brand-accent border-transparent', Icon: Trophy };
  return (
    <span
      className={`text-xs px-2 py-0.5 rounded-full border font-semibold inline-flex items-center gap-1 ${cls}`}
      data-testid={testId}
    >
      <Icon className="w-3 h-3" />
      {award}
    </span>
  );
};
